// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { environment } from './environment';

i18n
  .use(HttpBackend) // Load translations via HTTP (from public folder)
  .use(LanguageDetector) // Detect user language from browser
  .use(initReactI18next) // Pass to react-i18next
  .init({
    fallbackLng: {
      zh: ['zh-CN'], // Generic Chinese falls back to Simplified Chinese
      default: ['en'],
    },
    supportedLngs: [
      'en',
      'sv',
      'es',
      'ru',
      'nb',
      'ko',
      'ja',
      'it',
      'hi',
      'de',
      'fr',
      'fi',
      'nl',
      'da',
      'pt',
      'zh', // Generic Chinese (will use zh-CN translations)
      'zh-TW',
      'zh-CN',
    ],
    nonExplicitSupportedLngs: true, // Allow 'en-US' to match 'en', while keeping 'zh-TW' exact match
    debug: environment.i18nDebugMode,

    detection: {
      order: ['querystring', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      caches: [], // Don't persist language selection - always use browser settings
    },

    backend: {
      // Use function to map regional variants (en-US -> en) while preserving Chinese variants (zh-TW, zh-CN)
      loadPath: (lngs: readonly string[], namespaces: readonly string[]) => {
        const lng = lngs[0];
        const ns = namespaces[0];
        // Keep zh-TW and zh-CN as-is, but strip region from other languages (en-US -> en)
        const normalizedLng = lng.startsWith('zh-') ? lng : lng.split('-')[0];
        return `${environment.baseUrl}/locales/${normalizedLng}/${ns}.json`;
      },
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
